module.exports = __webpack_public_path__ + "img/step3-03.9f129b9f.jpg";